import { render, staticRenderFns } from "./MenuArticleComponent.vue?vue&type=template&id=71aa9a3a&"
import script from "./MenuArticleComponent.vue?vue&type=script&lang=js&"
export * from "./MenuArticleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports